<template>
  <b-sidebar id="sidebar-reuse" title="Buscar sesión a reutilizar" sidebar-class="bb-offcanvas-panel full"
             width="100%"
             bg-variant="white" right backdrop-variant="dark" backdrop no-header shadow
             @change="onLtiPanelVisibilityChange">
    <template #default="{ hide }">
      <div class="bb-offcanvas-panel-wrap">
        <div class="panel-main-content-height">
          <header class="page-header page-header-collapsed header-reuse">
            <div class="page-title-wrapper main-div-reuse-session">
              <h1 class="page-title">{{ $t("sessions.reusemodal.searchsession") }}</h1>
            </div>
            <button class="bb-close" v-on:click="hide">
              <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
            </button>
          </header>
          <div id="body-content" class="body-content instances-container body-content-reuse-session">
            <div class="page-controls">
              <div class="page-controls__control-row">
                <div class="page-controls__search reuse ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty"
                     v-bind:class="{'page-controls__search--opened': search_show }">
                  <div class="dropdown-search"
                       v-bind:class="{'dropdown-filter--range-active': selected_filter===$t('sessions.interval') }"
                  >
                    <button class="dropdown-search__toggle icon-button align-right " id="tooltip-target-search"
                            v-bind:class="{'d-none': search_show}"
                            @click="showSearch()">
                      <i class="isax isax-search-normal-1" />
                    </button>
                    <b-tooltip target="tooltip-target-search" triggers="hover">
                      {{ $t("sessions.reusemodal.searchsessions") }}
                    </b-tooltip>
                    <div class="dropdown-search__dropdown"
                         v-bind:class="{'d-none': !search_show}">
                      <i class="isax isax-search-normal-1" />
                      <input class="dropdown-search__input ng-pristine ng-valid ng-empty ng-touched" type="text"
                             v-bind:placeholder="$t('recordings.searchbyname')"
                             v-model="filter_name">
                      <div class="dropdown-search__controls">
                        <button class="button clear short dropdown-search__control ng-scope d-flex aling-items-center"
                                @click="hideSearch()">
                          <i class="isax isax-close-circle"/>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="searchcontrolsreuse" class="page-controls__filter recordings-search border-search-reuse">
                  <div
                    class="dropdown-filter select-wrapper"
                    v-bind:class="{'dropdown-filter--range-active': selected_filter===$t('sessions.interval') }"
                  >
                    <i class="isax isax-filter" />
                    <span class="dropdown-filter__select-label span-filter-by-text-reuse-session">{{ $t("sessions.filterby") }}</span>
                    <b-dropdown id="dropdown-right" right :text="selected_filter" variant=" dropdown-filter__select button-select dropdown">
                      <b-dropdown-item @click="nextSessions()">{{ $t("sessions.allnext") }}</b-dropdown-item>
                      <b-dropdown-item @click="pastSessions()">{{ $t("sessions.allpast") }}</b-dropdown-item>
                      <b-dropdown-item @click="intervalSessions()">{{ $t("sessions.interval") }}</b-dropdown-item>
                    </b-dropdown>
                    <form
                      class="date-range ng-valid ng-valid-date ng-valid-required ng-dirty ng-valid-parse ng-valid-before-start"
                      v-if="selected_filter===$t('sessions.interval')"
                    >
                      <div class="picker-input date">
                        <p>{{ $t("recordings.datefrom") }}</p>
                        <b-form-datepicker
                          today-button
                          v-bind:label-today-button="$t('sessions.today')"
                          reset-button
                          style="width: inherit;"
                          v-bind:label-reset-button="$t('sessions.clear')"
                          v-bind:label-help="$t('sessions.navigatemouse')"
                          label-no-date-selected="-"
                          id="start-date" type="text"
                          v-model="filter_start_date"
                          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                          locale="es"
                          @input="getClassrooms()">
                        </b-form-datepicker>
                      </div>
                      <div class="picker-input time">
                        <b-form-timepicker
                          v-bind:label-close-button="$t('buttons.close')"
                          label-no-time-selected="-"
                          id="start-time" type="text"
                          v-model="filter_start_time"
                          locale="es"
                          @hidden="getClassrooms()">
                        </b-form-timepicker>
                      </div>
                      <div class="picker-input date ml-4">
                        <p>{{ $t("recordings.dateto") }}</p>
                        <b-form-datepicker
                          today-button
                          v-bind:label-today-button="$t('sessions.today')"
                          reset-button
                          style="width: inherit;"
                          v-bind:label-reset-button="$t('sessions.clear')"
                          v-bind:label-help="$t('sessions.navigatemouse')"
                          label-no-date-selected="-"
                          id="end-date" type="text"
                          v-model="filter_end_date"
                          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                          locale="es"
                          @input="getClassrooms()">
                        </b-form-datepicker>
                      </div>
                      <div class="picker-input time">
                        <b-form-timepicker
                          v-bind:label-close-button="$t('buttons.close')"
                          label-no-time-selected="-"
                          id="end-time" type="text"
                          v-model="filter_end_time"
                          locale="es"
                          @hidden="getClassrooms()">
                        </b-form-timepicker>
                      </div>
                    </form>
                    <b-dropdown id="dropdown-right" right :text="selected_type_filter" variant=" dropdown-filter__select button-select dropdown">
                      <b-dropdown-item @click="typeSessions('Todos los sistemas')">{{ $t("sessions.reusemodal.everysystem") }}</b-dropdown-item>
                      <b-dropdown-item @click="typeSessions('Collaborate')">Collaborate</b-dropdown-item>
                      <b-dropdown-item @click="typeSessions('Adobe Connect')">Adobe Connect</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div id="sessioncontainer" class="full-width-content--small" v-show="!loading">
              <div v-if="!classrooms.length" class="no-content no-results">
                <span class="image pb-3">
                  <img class="site-logo" src="/static/img/miroodles_sticker.png">
                </span>
                <span class="no-content-title">{{ $t("sessions.reusemodal.mustselectfilter") }}</span>
              </div>
              <table v-else class="content-table reuse">
                <tbody>
                <tr class="content-table__header content-table__header--shadow">
                  <th class="medium-8">{{ $t("sessions.reusemodal.session") }}</th>
                  <th class="medium-4">{{ $t("sessions.reusemodal.starthour") }}</th>
                  <th class="medium-4">{{ $t("sessions.reusemodal.finishhour") }}</th>
                  <th class="medium-4">{{ $t("sessions.reusemodal.status") }}</th>
                  <th></th>
                </tr>
                <tr v-for="classroom in classrooms" v-bind:key="classroom.id" class="element-list-row element-reuse-row">
                  <td class="break-word content-table__emphasis">
                    <span class="inline-column-title ng-scope">{{ $t("sessions.reusemodal.session") }}:</span>
                    <bdi>{{ classroom.name }}</bdi><br/>
                    <span class="description" v-html="classroom.description"></span>
                  </td>
                  <td class="date">
                    <span class="date">
                      {{ classroom.start | moment("DD/MM/YYYY HH:mm") }}
                    </span>
                  </td>
                  <td class="date">
                    <span class="date">
                      {{ classroom.end | moment("DD/MM/YYYY HH:mm") }}
                    </span>
                  </td>
                  <td class="status">
                    <span v-if="isOngoing(classroom)">
                      <div class="d-flex align-items-center session-state state-in-progress">
                        <bdi class="progress-status-sessions">{{ $t("sessions.reusemodal.ongoing") }}</bdi>
                      </div>
                    </span>
                    <span v-if="!isOngoing(classroom)">
                      <div class="d-flex align-items-center session-state state-not-started" v-if="notYetStarted(classroom) && classroom.end">
                        <bdi class="progress-status-sessions">{{ $t("sessions.reusemodal.notstarted") }}</bdi>
                      </div>
                      <div class="d-flex align-items-center session-state state-not-started" v-if="notYetStarted(classroom) && !classroom.end">
                        <bdi class="progress-status-sessions">{{ $t("sessions.reusemodal.notstarted") }}</bdi>
                      </div>
                      <div class="d-flex align-items-center session-state state-finished" v-if="hasEnded(classroom)">
                        <bdi class="progress-status-sessions">{{ $t("sessions.finished") }}</bdi>
                      </div>
                    </span>
                  </td>
                  <td class="item-controls text-left">
                    <button class="button secondary button-action-reuse-session" @click="reuseSession(classroom)">{{ $t("sessions.reusemodal.reuse") }}</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer v-if="classrooms_pagination.limit < classrooms_total" class="page-footer session-list-pagination">
            <b-pagination
              v-model="classrooms_pagination_current"
              :total-rows="classrooms_total"
              :per-page="classrooms_pagination.limit"
              align="center"
              aria-controls="report-content-table"
            ></b-pagination>
          </footer>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import CloudDownloadOutlineIcon from 'vue-material-design-icons/CloudDownloadOutline.vue'
import jwtMixin from '../../../mixins/jwtMixin'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import ltiFrameMixin from '../../../mixins/ltiFrameMixin'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'

export default {
  name: 'ReuseSessionSidebar',
  components: {CloseIcon, KeyboardReturnIcon, CloudDownloadOutlineIcon, MagnifyIcon},
  mixins: [jwtMixin, utilitiesMixin, ltiFrameMixin],
  props: [],
  mounted () {
    this.$moment.locale('es')
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      loading: false,
      classrooms: [],
      classrooms_total: 0,
      classrooms_pagination_current: 1,
      classrooms_pagination: {
        limit: this.defaultPagination(),
        offset: 0
      },
      classrooms_pagination_options: this.paginationOptions(),
      selected_filter: this.$i18n.t('sessions.allnext'),
      selected_type_filter: this.$i18n.t('sessions.reusemodal.everysystem'),
      search_show: false,
      filter_start_date: null,
      filter_start_time: null,
      filter_end_date: null,
      filter_end_time: null,
      filter_name: null,
      waiting_filter_name: false
    }
  },
  watch: {
    classrooms_pagination_current: {
      handler: function (value) {
        // CMM: se establece la paginación acorde a la página activada
        this.classrooms_pagination.offset = this.classrooms_pagination.limit * (this.classrooms_pagination_current - 1)
        this.getClassrooms()
      }
    },
    filter_name: function (val) {
      let vueComponent = this
      if (!this.waiting_filter_name) {
        setTimeout(() => {
          vueComponent.getClassrooms()
          this.waiting_filter_name = false
        }, 1500)
      }
      this.waiting_filter_name = true
    }
  },
  methods: {
    getClassrooms () {
      let vueComponent = this
      this.classrooms = []
      this.classrooms_total = 0
      let filterParams = {
        limit: this.classrooms_pagination.limit,
        offset: this.classrooms_pagination.offset
      }
      // CMM: Configuración de filtros
      if (vueComponent.filter_start_date) {
        if (!this.filter_start_time) {
          this.filter_start_time = '00:00'
        }
        filterParams.startTime = window.moment(vueComponent.filter_start_date + ' ' + this.filter_start_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      } else {
        vueComponent.filter_start_time = null
      }
      if (vueComponent.filter_end_date) {
        if (!this.filter_end_time) {
          this.filter_end_time = '23:59'
        }
        filterParams.endTime = window.moment(vueComponent.filter_end_date + ' ' + this.filter_end_time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      } else {
        vueComponent.filter_end_time = null
      }
      if (vueComponent.selected_type_filter) {
        if (vueComponent.selected_type_filter === 'Collaborate') {
          filterParams.targetSystem = 'COLLAB'
        } if (vueComponent.selected_type_filter === 'Adobe Connect') {
          filterParams.targetSystem = 'CONNECT'
        }
      }
      if (vueComponent.filter_name) {
        filterParams.name = vueComponent.filter_name
      }
      filterParams.targetStatus = true
      window.axios.get('classrooms/', {params: filterParams}).then((response) => {
        // CMM: Se recupera la información de las clases, sin enrollment del usuario (modo consulta)
        this.classrooms_total = response.data.size
        response.data.results.forEach(function (classroom) {
          vueComponent.classrooms.push(classroom)
        })
        this.loading = false
      })
    },
    reuseSession (classroom) {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-reuse')
      this.$emit('reuse', classroom)
    },
    hideSearch () {
      this.search_show = false
      this.waiting_filter_name = false
    },
    showSearch () {
      this.search_show = true
    },
    nextSessions () {
      this.selected_filter = this.$i18n.t('sessions.allnext')
      this.filter_start_date = window.moment().format('YYYY-MM-DD')
      this.filter_start_time = window.moment().format('HH:mm')
      this.filter_end_date = null
      this.filter_end_time = null
      this.resetPagination()
    },
    pastSessions () {
      this.selected_filter = this.$i18n.t('sessions.allpast')
      this.filter_start_date = null
      this.filter_start_time = null
      this.filter_end_date = window.moment().format('YYYY-MM-DD')
      this.filter_end_time = window.moment().format('HH:mm')
      this.resetPagination()
    },
    intervalSessions () {
      this.selected_filter = this.$i18n.t('sessions.interval')
      this.filter_start_date = window.moment().format('YYYY-MM-DD')
      this.filter_start_time = '00:00'
      this.filter_end_date = window.moment().format('YYYY-MM-DD')
      this.filter_end_time = '23:59'
      this.resetPagination()
    },
    typeSessions (type) {
      this.selected_type_filter = type
      this.resetPagination()
    },
    resetPagination () {
      // CMM: Si no estaba en la páginia inicial se cambia a la primera. El cambio lanza la recarga del listado
      if (this.classrooms_pagination_current !== 1) {
        this.classrooms_pagination_current = 1
      } else {
        this.getClassrooms()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsModals/ReuseSessionSidebar.vue